import React from 'react'
import { Link } from 'react-router-dom'

import { conditionalLink } from '../../conditional-link'

const ListItem = ({ record, path, selected = false }) => (
  <div className="listItemContent">
    <div>
      {conditionalLink(
        !selected,
        <Link to={path}>
          <div className="listItemContent--heading">{record.gov_id}</div>
        </Link>
      )}
    </div>
  </div>
)

export default ListItem



// WEBPACK FOOTER //
// ./src/providers-registrations/views/index.jsx